import React, { Component } from 'react';
import Submenu from './Submenu';
import { Link } from 'react-router-dom';
import Icons from '../../../common/icons/Icons';
import Icon from '@mdi/react';
import { mdiChevronDown } from '@mdi/js';

class Menu extends Component {
  render() {
    const { pathname, dataMenu, dataAuth, openMenu, handleToggleSubmenu, isShrunk } =
      this.props;
    let url = dataMenu.alias;
    let authM = dataAuth.m;
    let authSubm = dataAuth.subm;
    const regex = new RegExp(url);
    const isActive = regex.test(pathname);
    const accessMenu = authM[dataMenu.id + '_view'];
    let rootPath = '/' + pathname.split('/').filter((e) => /\S/.test(e))[0];
    
    const hideLabel = isShrunk ? { display: 'none' } : {};

    return (
      <>
        {accessMenu && (
          <li style={{ paddingRight: 1 }}>
            {dataMenu.subm.length === 0 && (
              <Link
                to={dataMenu.url}
                className={`disable-select is-size-6 custom-text-overflow custom-hover-light-info${
                  rootPath === dataMenu.url ? ' is-active' : ''
                }`}
                style={
                  isShrunk
                    ? {
                        justifyContent: 'center',
                        paddingLeft: 0,
                        paddingRight: 0,
                      }
                    : {}
                }
              >
                <span className='flex justify-start align-center' style={isShrunk ? { justifyContent: 'center' } : {}}>
                  <Icons color={'#ffffff'} icon={dataMenu.icon} />
                  <span
                    className='menu-label custom-menu-label'
                    style={{ marginLeft: 2, ...hideLabel }}
                  >
                    {dataMenu.title}
                  </span>
                </span>
              </Link>
            )}
            {dataMenu.subm.length > 0 && (
              <div
                onClick={() => !isShrunk && handleToggleSubmenu(dataMenu.title)}
                className={`has-submenu flex justify-between align-center custom-text-overflow is-size-6 disable-select${
                  isActive === true
                    ? ' custom-background-active'
                    : ' has-text-light'
                }`}
                style={
                  isShrunk
                    ? {
                        justifyContent: 'center',
                        paddingLeft: 0,
                        paddingRight: 0,
                        cursor: 'default',
                      }
                    : {}
                }
              >
                <span
                  className='has-submenu flex justify-start align-center'
                  style={
                    isShrunk
                      ? { paddingLeft: 0, justifyContent: 'center' }
                      : { paddingLeft: 5 }
                  }
                >
                  <Icons color={'#ffffff'} icon={dataMenu.icon} />
                  <span
                    className='menu-label custom-menu-label'
                    style={{ marginLeft: 2, ...hideLabel }}
                  >
                    {dataMenu.title}
                  </span>
                </span>
                <span
                  className={`mr-2 ${
                    openMenu.title === dataMenu.title && openMenu.open
                      ? 'arrow'
                      : 'arrow-rotated'
                  }`}
                  style={hideLabel}
                >
                  <Icon path={mdiChevronDown} size={0.65} />
                </span>
              </div>
            )}
            {!isShrunk && (
              <ul
              className={
                openMenu.title === dataMenu.title && openMenu.open
                  ? 'submenu-detail submenu-detail-open'
                  : 'submenu-detail'
              }
            >
              {dataMenu.subm.map((subm) => (
                <Submenu
                  key={subm.id}
                  subm={subm}
                  authSubm={authSubm}
                  pathname={pathname}
                />
              ))}
              </ul>
            )}
          </li>
        )}
      </>
    );
  }
}

export default Menu;
